module.exports = __webpack_public_path__ + "static/media/Muli-Light.9140e610.ttf";